export const getSectionId = (index) =>
  `section-${String(index + 1).padStart(2, '0')}`;

export const getShopAnchorId = (pointIndex, shopIndex) =>
  `shop-${pointIndex}-${shopIndex}`;

export const getArticleSections = (article) => {
  if (Array.isArray(article?.spots)) return article.spots;
  if (Array.isArray(article?.points)) return article.points;
  return [];
};

export const getGoogleMapEmbedUrl = (mapUrl, fallbackQuery) => {
  const defaultQuery = fallbackQuery || '';

  if (!mapUrl && !defaultQuery) return '';

  try {
    const url = new URL(mapUrl);

    const query =
      url.searchParams.get('query') ||
      url.searchParams.get('q') ||
      defaultQuery;

    return `https://www.google.com/maps?q=${encodeURIComponent(
      query
    )}&output=embed`;
  } catch {
    return `https://www.google.com/maps?q=${encodeURIComponent(
      defaultQuery || mapUrl
    )}&output=embed`;
  }
};
